import { render, staticRenderFns } from "./PretrainingVisionWarning.vue?vue&type=template&id=08f2552e&"
import script from "./PretrainingVisionWarning.vue?vue&type=script&lang=js&"
export * from "./PretrainingVisionWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports